import { Box, Skeleton, Tab, Tabs, Typography } from '@mui/material';
import { ArchiveViewOptions } from '../../utils/templateConstants';
import useTemplateSx from '../../hooks/useTemplateSx';
import OptinUsersTabButton from './OptinUsersTabButton';

const STATUS_TAB_ITEMS = [
  { id: 'all', status: '', archived: 'false', label: 'All', countKey: 'total', badgeVariant: 'neutral' },
  { id: 'approved', status: 'APPROVED', archived: 'false', label: 'Approved', countKey: 'approved', badgeVariant: 'success' },
  { id: 'pending', status: 'PENDING', archived: 'false', label: 'Pending', countKey: 'pending', badgeVariant: 'warning' },
  { id: 'rejected', status: 'REJECTED', archived: 'false', label: 'Rejected', countKey: 'rejected', badgeVariant: 'danger' },
  { id: 'archived', status: '', archived: 'true', label: 'Archived', countKey: 'archived', badgeVariant: 'neutral' },
];

function getStatusTabIndex(status = '', archived = 'false') {
  if (archived === 'true') {
    return STATUS_TAB_ITEMS.findIndex((item) => item.id === 'archived');
  }
  const index = STATUS_TAB_ITEMS.findIndex(
    (item) => item.archived === 'false' && item.status === (status || '')
  );
  return index >= 0 ? index : 0;
}

function TabCountBadge({ count, variant, styles }) {
  return (
    <Box component="span" sx={styles.statusTabBadge(variant)}>
      {count ?? 0}
    </Box>
  );
}

export default function TemplateStatusTabs({
  status = '',
  archived = 'false',
  counts = {},
  isLoading = false,
  showOptin = false,
  isOptinView = false,
  onTabChange,
  onOptinSelect,
}) {
  const styles = useTemplateSx();
  const statusActiveIndex = getStatusTabIndex(status, archived);
  const tabsValue = isOptinView ? false : statusActiveIndex;

  const handleStatusChange = (_event, index) => {
    if (index === false || index == null) return;
    const tab = STATUS_TAB_ITEMS[index];
    if (!tab || index === statusActiveIndex) return;

    const patch = {
      status: tab.status,
      statusObj: null,
      archived: tab.archived,
      archivedObj: tab.archived === 'true' ? ArchiveViewOptions[1] : ArchiveViewOptions[0],
      page: 0,
    };
    onTabChange?.(patch);
  };

  const handleOptinClick = () => {
    if (isOptinView) return;
    onOptinSelect?.();
  };

  return (
    <Box sx={styles.statusTabsBar}>
      <Box sx={styles.statusTabsMain}>
        <Tabs
          value={tabsValue}
          onChange={handleStatusChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{...styles.statusTabs , '& .MuiButtonBase-root.Mui-disabled':{opacity:0.5}}}
        >
          {STATUS_TAB_ITEMS.map((item, index) => (
            <Tab
              key={item.id}
              disableRipple
              label={
                <Box sx={styles.statusTabLabel}>
                  <Typography component="span" sx={styles.statusTabText}>
                    {item.label}
                  </Typography>
                  {item.countKey ? (
                    isLoading ? (
                      <Skeleton variant="rounded" width={28} height={18} sx={{ borderRadius: 999 }} />
                    ) : (
                      <TabCountBadge
                        count={counts[item.countKey]}
                        variant={item.badgeVariant}
                        styles={styles}
                      />
                    )
                  ) : null}
                </Box>
              }
              {...{ id: `template-status-tab-${index}`, 'aria-controls': `template-status-panel-${index}` }}
            />
          ))}
        </Tabs>
      </Box>

      {showOptin ? (
        <Box sx={styles.statusTabsOptinSlot}>
          <OptinUsersTabButton
            active={isOptinView}
            count={counts.optin}
            isLoading={isLoading}
            onClick={handleOptinClick}
          />
        </Box>
      ) : null}
    </Box>
  );
}
